import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function SidebarFooter() {
  const { t } = useTranslation();

  return (
    <div className="my-4 fs-12">
      <a href="/rules" target="_blank" rel="noopener noreferrer" className="link-secondary d-block text-decoration-none mb-1">
        <FontAwesomeIcon icon={["fas", "fa-gavel"]} className="me-2" />
        {t("favluv_rules")}
      </a>
      <a href="/terms" target="_blank" rel="noopener noreferrer" className="link-secondary d-block text-decoration-none mb-1">
        <FontAwesomeIcon icon={["fas", "fa-file-contract"]} className="me-2" />
        {t("terms_and_conditions")}
      </a>
      <a href="/privacy" target="_blank" rel="noopener noreferrer" className="link-secondary d-block text-decoration-none mb-1">
        <FontAwesomeIcon icon={["fas", "fa-shield-alt"]} className="me-2" />
        {t("privacy_policy")}
      </a>
      <a href="/cookies" target="_blank" rel="noopener noreferrer" className="link-secondary d-block text-decoration-none mb-1">
        <FontAwesomeIcon icon={["fas", "fa-cookie-bite"]} className="me-2" />
        {t("cookie_policy")}
      </a>
      <a href="/api-docs" target="_blank" rel="noopener noreferrer" className="link-secondary d-block text-decoration-none mb-1">
        <FontAwesomeIcon icon={["fas", "fa-book"]} className="me-2" />
        {t("api_documentation")}
      </a>
      <a href="/chat-token" target="_blank" rel="noopener noreferrer" className="link-secondary d-block text-decoration-none mb-1">
        <FontAwesomeIcon icon={["fas", "fa-robot"]} className="me-2" />
        {t("chatbot_setup_guide")}
      </a>
      <a href="https://docs.google.com/forms/d/e/1FAIpQLScxPi-1g35gr0U7QUeMr2HqIWQB_FMK5MlrJ9rhWneSvn2Mog/viewform?usp=sharing&ouid=106922785454417437063" target="_blank" rel="noopener noreferrer" className="link-secondary d-block text-decoration-none mb-1">
        <FontAwesomeIcon icon={["fas", "fa-bug"]} className="me-2" />
        {t("bug_report")}
      </a>
      <a href="/contact" target="_blank" rel="noopener noreferrer" className="link-secondary d-block text-decoration-none mb-1">
        <FontAwesomeIcon icon={["fas", "fa-envelope"]} className="me-2" />
        {t("contact_us")}
      </a>
      <p>
        &copy; 2024-2025 Favluv by Wishcan Inc.
      </p>
    </div>
  );
}

export default SidebarFooter;
